/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_Correct_NoteInputs */



/**
* | output |
* | --- |
* | "Reading speed too high - could not be corrected automatically" |
*
* @param {Auto_Correct_NoteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_correct_note = /** @type {((inputs?: Auto_Correct_NoteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_Correct_NoteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vitesse de lecture trop élevée - correction automatique impossible")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lesegeschwindigkeit zu hoch - konnte nicht automatisch korrigiert werden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Velocità di lettura troppo alta - non è stato possibile correggerla automaticamente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Слишком высокая скорость чтения - не удалось исправить автоматически")
	if (locale === "es") return /** @type {LocalizedString} */ ("Velocidad de lectura demasiado alta - no se pudo corregir automáticamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("阅读速度过高 - 无法自动更正")
	if (locale === "ja") return /** @type {LocalizedString} */ ("読み取り速度が速すぎます - 自動修正できませんでした")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पठन गति बहुत अधिक है - स्वचालित रूप से ठीक नहीं किया जा सका")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Velocidade de leitura demasiado alta - não foi possível corrigir automaticamente")
	return /** @type {LocalizedString} */ ("Reading speed too high - could not be corrected automatically")
});